import { Action, ActionReducer, State } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { merge } from 'lodash-es';
import { stripDerivedState } from './localstorage-sync.reducer.helpers';

const INIT_ACTION = '@ngrx/store/init';
const UPDATE_ACTION = '@ngrx/store/update-reducers';

const mergeReducer = (state$: State<any>, rehydratedState$: State<any>, action: Action): State<any> => {
  if ((action.type === INIT_ACTION || action.type === UPDATE_ACTION) && rehydratedState$) {
    const cleanedRehydrated = stripDerivedState(rehydratedState$);
    state$ = merge({}, state$, cleanedRehydrated) as State<any>;
  }

  return state$;
};

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    keys: ['job-match'],
    rehydrate: true,
    mergeReducer
  })(reducer);
}
